import { IFilter } from '../../types/advancedFilters';
import { RentTermsContainer } from '../../containers/advancedFilters/RentTermsContainer';

export const rentTerms: IFilter = {
  component: RentTermsContainer,
};
